export const ACRONYMS = [];
